import { useApiQuery } from '../../hooks/useApiQuery';
import { StoryList } from '../../types/commerce';
import { SocialLinks } from '../Footer/Footer';
import StoryCard from './StoryCard';
import './Stories.css';

export default function StoriesStrip() {
  const query = useApiQuery<StoryList>('/commerce/stories?offset=0&limit=3');
  return (
    <section className="stories-strip page-container" aria-labelledby="latest-stories">
      <h2 id="latest-stories">From Resham Tales</h2>
      {query.loading && <p role="status">Loading stories…</p>}
      {query.error && (
        <p>
          Stories are temporarily unavailable. <button onClick={query.reload}>Try stories again</button>
        </p>
      )}
      <div className="stories-grid">
        {query.data?.items.map((story) => <StoryCard key={story.id} story={story} />)}
      </div>
      <SocialLinks />
    </section>
  );
}
